// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Cm-z","trustedRetailerTooltipWrapper":"Dm-z"};